import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Modal } from '@ontruck/orc';

import * as http from 'utils/http';
import { createJourneyLog } from 'redux/modules/log/effects';
import { logChangesGenerator } from 'redux/modules/log/log-changes';
import { Loading } from 'components/Loading';

const LOG_ACTION = 'DELETE_CARGO_MANIFEST';

class CargoManifestDelete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      loading: false,
    };
  }

  handleDeleteClick() {
    this.setState(
      {
        error: false,
      },
      () => {
        const { createJourneyLog, journey, cargoManifest, stopId, onDelete } = this.props;
        const { loading } = this.state;

        if (loading) return;

        this.setState({ loading: true });
        http
          ._delete(cargoManifest.generate_cargo_manifest_url)
          .then(() => http.get(journey.url))
          .then((res) => {
            const stop_company_name = _.get(journey, `stops.${stopId}.address.company_name`);
            const stopNumber = stopId + 1;
            const changes = logChangesGenerator.get(LOG_ACTION, {
              stop_company_name: stop_company_name,
              stop: stopNumber,
              cargo_manifest_url: cargoManifest.cargo_manifest_url,
            });
            createJourneyLog({
              action: LOG_ACTION,
              journeyId: journey.id,
              editableAfterCreation: true,
              changes,
            });

            return res;
          })
          .then((payload) => {
            this.setState({ loading: false });
            onDelete(payload);
          })
          .catch((e) => this.setState({ error: true, loading: false }));
      }
    );
  }

  render() {
    const { show, onClose, intl } = this.props;
    const { loading } = this.state;
    const t = intl.messages.components.CargoManifestDelete;

    return (
      <Modal
        show={show}
        onClose={onClose}
        size="S"
        headerComponent={t.delete_files}
        primaryAction={t.confirm_removal}
        secondaryAction={t.do_not_delete}
        onAccept={() => this.handleDeleteClick.call(this)}
        onCancel={onClose}
      >
        {loading && <Loading />}
      </Modal>
    );
  }
}

const actionCreators = {
  createJourneyLog,
};

export default injectIntl(connect(null, actionCreators)(CargoManifestDelete));
